import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
//icons
import { BsSearch } from 'react-icons/bs';
import { GiBroom } from 'react-icons/gi';
//api
import { getProductComments } from 'api/libelista';
//helpers
import { formatDateToSpanish } from 'helpers';
//components
import CustomInput from 'components/backoffice/customInput';
import CustomTable from 'components/backoffice/customTable';
import DropdownIcons from 'components/backoffice/dropDownIcons';
import ButtonCustom from 'components/backoffice/buttonCustom';

const colsComments = [
  'Título',
  'Comentario',
  'Usuario',
  'Nickname',
  'Producto',
  'Fecha de creación',
  ''
];

const Comments = () => {
  const navigate = useNavigate();
  const [listComments, setListComments] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [noResults, setNoResults] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const query = {
    search: inputValue,
    page: 1,
    page_size: 10,
  };
  const searchQuery = new URLSearchParams(query);
  const queryString = searchQuery.toString();

  const getListComments = async () => {
    setIsLoading(true);
    const { data, status } = await getProductComments(queryString);
    if (status === 200) {
      setListComments(data?.results);
      setNoResults(data?.results.length === 0);
    } else {
      setListComments([]);
      setNoResults(true);
    }
    setIsLoading(false);
  };

  const handleValue = (e) => {
    setInputValue(e.target.value);
  };

  useEffect(() => {
    getListComments();
  }, []);

  const handleClear = () => {
    setInputValue('');
    setNoResults(false);
    navigate('/intranet/comments', { replace: true });
  };

  return (
    <div className="h-100 ml-70">
      <div className="d-flex mt-3 justify-content-between">
        <h1 className="text-light mt-5">Comentarios</h1>
      </div>
      <div className="d-flex my-5">
        <CustomInput
          //handleSubmit={(e) => handleSubmit(e)}
          placeholder="Buscar por nombre "
          icon={<BsSearch color="#161A25" className="icon-search" />}
          type={'search'}
        />
        <ButtonCustom onClick={handleClear} color="terciary">
          <GiBroom />
        </ButtonCustom>
      </div>
      <CustomTable cols={colsComments} noResults={noResults} isLoading={isLoading} className="custom-table" page={1}>
        {listComments?.map((listComment, index) => {
          return (
            <tr key={listComment.id}>
              <td>{listComment.title}</td>
              <td>{listComment.comentary}</td>
              <td>{listComment.user}</td>
              <td>{listComment.nickname}</td>
              <td>{listComment.product}</td>
              <td>{formatDateToSpanish(listComment.created)}</td>
              <td className=" item-dropdown text-end">
                <DropdownIcons idItem={index} />
              </td>
            </tr>
          );
        })}
      </CustomTable>
    </div>
  );
};

export default Comments;
